<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="taskDispatchBills"
        :table-footer-msg="tableFooterMsg"
        @select="selectHandle"
        @delete="deleteHandle"
        @addOrEdit="addEditHandle"
        @update="getTableFooterMsg">
      <template slot="otherBtn">
        <el-button :disabled="!selection.length||loadingSche" type="primary" @click="sureOutPut"> 确认排产</el-button>
        <el-button :disabled="!selection.length||loadingUnsche" type="primary" @click="repealOutPut"> 撤销排产</el-button>
        <el-button :disabled="selection.length!==1||loadingPrintCode" type="primary" @click="printCode()">
          标签打印
        </el-button>
        <el-button :disabled="selection.length!==1||loadingPrintCode" type="primary" @click="printCode3()">
          标签打印V2
        </el-button>
        <el-button :disabled="selection.length===0||loadingPrintTask" type="primary" @click="printTask()">工单打印
        </el-button>
        <el-button :disabled="selection.length===0" type="primary" @click="printTaskWithSop()">工单打印(操作卡)</el-button>
      </template>
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" label-width="80px" @keyup.enter.native="loadData(1)">
            <el-form-item label="工单编号">
              <el-input v-model.trim="filter.productionOrderNo" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="派工单号">
              <el-input v-model.trim="filter.billNo" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="物料编号">
              <el-input v-model.trim="filter.materialNo" placeholder="请输入" clearable/>
            </el-form-item>
            <!--            <el-form-item label="物料类型">-->
            <!--              <el-select v-model="filter.materialTypeId" placeholder="请选择" clearable>-->
            <!--                <el-option-->
            <!--                    v-for="item in materialTypeList"-->
            <!--                    :key="item.pkid"-->
            <!--                    :label="item.materialTypeName"-->
            <!--                    :value="item.pkid"/>-->
            <!--              </el-select>-->
            <!--            </el-form-item>-->
            <el-form-item label="物料类型">
              <el-select
                  v-model="materialTypeList"
                  :popper-append-to-body="false"
                  class="biddingStageSty"
                  multiple
                  clearable
                  placeholder="请选择"
                  @change="handleSelectMaterialType">
                <el-option v-for="item in materialTypeOptions" :key="item.value" :label="item.name"
                           :value="item.value"/>
              </el-select>
            </el-form-item>
            <el-form-item label="物料名称">
              <el-input v-model.trim="filter.materialName" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="规格型号">
              <el-input v-model.trim="filter.materialSpecification" placeholder="请输入" clearable/>
            </el-form-item>
            <!--            <el-form-item label="工作中心：">-->
            <!--              <el-input v-model.trim="filter.workCenterName" placeholder="请选择工作中心" clearable>-->
            <!--                <el-button slot="append" icon="el-icon-search" @click="$refs.workCenterSelect.open()"/>-->
            <!--              </el-input>-->
            <!--            </el-form-item>-->
            <el-form-item label="工单状态">
              <el-select v-model="filter.status" placeholder="请选择">
                <el-option label="待排产" :value="10"/>
                <el-option label="已排产" :value="20"/>
              </el-select>
            </el-form-item>
            <el-form-item label="客户名称">
              <el-input v-model.trim="filter.customerName" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="最终客户">
              <el-input v-model.trim="filter.finalCustomerName" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="交货日期">
              <el-date-picker
                  v-model="deliveryDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="deliveryDateRangeChange"/>
            </el-form-item>
            <el-form-item label="销售单号">
              <el-input v-model.trim="filter.salesOrderNo" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="合同号">
              <el-input v-model.trim="filter.customerContractNo" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="工作中心">
              <el-input type="textarea" v-model="filter.workCenterNames" placeholder="请输入" clearable/>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </view-table>
    <material-code-modal ref="materialCodeModal"/>
    <material-code-modal3 ref="materialCodeModal3"/>
    <print-order-modal ref="printOrderModal"/>
    <print-order-modal-with-sop-list ref="printOrderWithSop"/>
    <inventory-select ref="inventorySelect" @select="inventorySelect"/>
    <print-production-card2 ref="printProductionCard2"/>
    <!-- 工作中心选择 -->
    <work-center-select ref="workCenterSelect" @select="workCenterSelect"/>
    <production-order-preview ref="detailPage"/>
    <work-order-issued-edit ref="workOrderIssuedEdit" :product-order-info="orderInfo" @save-success="saveSuccess"/>
    <material-stock-preview ref="stockPreview"/>
  </div>
</template>
<script>
  import ViewTable from "@/components/ViewTable";
  import MaterialCodeModal from "./MaterialCodeModal";
  import MaterialCodeModal3 from "./MaterialCodeModal3";
  import PrintOrderModal from "./PrintOrderModalList";
  import printProductionCard2 from "./PrintProductionCard2";
  import InventorySelect from "@/views/StoreManagement/Inventory/InventorySelect";
  import WorkCenterSelect from "@/views/information/WorkCenter/WorkCenterSelect";
  import ProductionOrderPreview from "./ProductionOrderPreview.vue";
  import WorkOrderIssuedEdit from "@/views/ProductionManagement/ProductionPlan/WorkOrderIssuedEdit";
  import MaterialStockPreview from "@/views/ProductionManagement/ProductionProject/MaterialStockPreview";
  import PrintOrderModalWithSopList from "@/views/ProductionManagement/ProductionOrder/PrintOrderModalWithSopList";

  export default {
    name: "ProductionOrderList",
    components: {
      ViewTable,
      InventorySelect,
      WorkCenterSelect,
      MaterialCodeModal,
      MaterialCodeModal3,
      printProductionCard2,
      PrintOrderModal,
      PrintOrderModalWithSopList,
      ProductionOrderPreview,
      WorkOrderIssuedEdit,
      MaterialStockPreview,
    },
    data() {
      return {
        limits: {
          delAuth: this.$auth(243),
          editAuth: this.$auth(284),
        },
        loadingSche: false,
        loadingUnsche: false,
        loadingPrintCode: false,
        loadingPrintTask: false,
        orderInfo: null,
        labelPrintAuth: this.$auth(21),
        nameplatePrintAuth: this.$auth(389),
        printAuth: this.$auth(22),
        disabled: false,
        dateRange: "",
        searchShow: false,
        finishDateRange: "",
        submitDateRange: [],
        deliveryDateRange: [],
        materialTypeList: [],
        materialTypeOptions: [],
        filter: {
          productionOrderNo: "",
          billNo: "",
          materialNo: "",
          materialTypeId: "",
          materialTypeIds: "",
          materialName: "",
          materialSpecification: "",
          workCenterNames: "",
          status: 10,  // 默认查询待排产的派工单
          customerName: "",
          finalCustomerName: "",
          soDeliveryStartDate: "",
          soDeliveryEndDate: "",
          salesOrderNo: "",
          customerContractNo: "",
        },
        inventoryId: "",
        selection: [], // 当前选中的数据
        tableFooterMsg: "",
        columnsProperty: [
          {
            key: "billNo",
            width: 120,
            align: "center",
            render: (h, params) => {
              return h(
                  "span",
                  {
                    style: {
                      color: "#2d8cf0",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        this.$refs.detailPage.open(params.row);
                      },
                    },
                  },
                  params.row.billNo,
              );
            },
          },
          {
            title: "采购到料状态",
            key: "purchaseStatus",
            width: 100,
            align: "center",
            render: (h, params) => {
              return h(
                  "span",
                  {
                    style: {
                      color: params.row.purchaseStatus === "缺料" ? "red" : "#2d8cf0",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        if (params.row.purchaseStatus) {
                          this.$refs.stockPreview.open(params.row.productionOrderNo, true);
                        }
                      },
                    },
                  },
                  params.row.purchaseStatus,
              );
            },
          },
          {
            key: "action",
            align: "center",
            width: 150,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    watch: {
      "filter.soDeliveryStartDate": {
        handler(newVal) {
          if (newVal) {
            this.deliveryDateRange = [];
            this.deliveryDateRange.push(this.filter.soDeliveryStartDate);
            this.deliveryDateRange.push(this.filter.soDeliveryEndDate);
          }
        },
      },
      "filter.materialTypeIds": {
        handler(val) {
          if (val) {
            this.materialTypeList = [];
            this.materialTypeOptions.map(item => {
              val.split(",").forEach((s) => {
                if (parseInt(s) === parseInt(item.value)) {
                  this.materialTypeList.push(item.value);
                }
              });
            });
          }
        },
      },
    },

    created() {
      this.getMaterialTypeList();
    },
    mounted() {
      // this.getMaterialTypeList();
      // this.loadData(1);
    },
    methods: {
      getMaterialTypeList() {
        this.materialTypeOptions = [];
        this.$http.get("basic", "materialTypes/getAllList").then((res) => {
          if (res.success) {
            res.data.forEach((item) => {
              let temp = {"name": item.materialTypeName, "value": item.pkid};
              this.materialTypeOptions.push(temp);
            });
          }
        });
      },
      handleSelectMaterialType(value) {
        if (value.length) {
          // this.materialTypeList = value;
          this.filter.materialTypeIds = value.join(",");
        } else {
          // this.materialTypeList = [];
          this.filter.materialTypeIds = "";
        }
      },
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
        this.getTableFooterMsg();
      },
      getTableFooterMsg() {
        this.tableFooterMsg = "总数量:0";
        this.$http.get("basic", "taskDispatchBills/selectCount", this.filter).then((res) => {
          if (res.success) {
            this.tableFooterMsg = "总数量:" + res.data;
          }
        });
      },
      dateRangeChange(date) {
        if (date) {
          this.filter.planStartFrom = date[0];
          this.filter.planStartTo = date[1];
        } else {
          this.filter.planStartFrom = "";
          this.filter.planStartTo = "";
        }
      },

      finishDateRangeChange(date) {
        if (date) {
          this.filter.planFinishFrom = date[0];
          this.filter.planFinishTo = date[1];
        } else {
          this.filter.planFinishFrom = "";
          this.filter.planFinishTo = "";
        }
      },

      deliveryDateRangeChange(date) {
        if (date) {
          this.filter.soDeliveryStartDate = date[0];
          this.filter.soDeliveryEndDate = date[1];
        } else {
          this.filter.soDeliveryStartDate = "";
          this.filter.soDeliveryEndDate = "";
        }
      },

      submitDateRangeChange(date) {
        if (date) {
          this.filter.soSubmitStartTime = date[0];
          this.filter.soSubmitEndTime = date[1];
        } else {
          this.filter.soSubmitStartTime = "";
          this.filter.soSubmitEndTime = "";
        }
      },
      printTaskWithSop() {
        this.$refs.printOrderWithSop.open(this.selection);
      },
      handleClick() {
        this.dateRange = [];
        this.finishDateRange = [];
        this.deliveryDateRange = [];
        this.submitDateRange = [];
      },

      workCenterSelect(row) {
        this.filter.workCenterName = row.workCenterName;
        this.loadData(1);
      },

      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      addEditHandle(row) {
        this.$refs.workOrderIssuedEdit.open(row.pkid, false);
      },

      // 删除
      deleteHandle(row) {

        this.$http.delete("basic", "taskDispatchBills", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData(1);
            this.$message.success("删除成功");
          }
        });

      },

      //未排产可以编辑删除
      otherAuth(row) {
        if (row.status === 10) {
          return {
            editAuth: false,
            delAuth: false,
          };
        } else {
          return {
            editAuth: true,
            delAuth: true,
          };
        }
      },
      saveSuccess() {
        this.loadData(1);
        this.$emit("save-success");
      },
      //打印工单
      printTask() {
        this.$refs.printOrderModal.open(this.selection);
      },

      // 标签打印
      printCode() {
        this.loadingPrintCode = true;
        this.$http.get("basic", `productionManage/printsn?id=${this.selection[0].pkid}`).then((resp) => {
          if (resp.success) {
            if (resp.data.length) {
              this.$refs.materialCodeModal.open(resp.data, this.selection[0]);
            }
            this.loadingPrintCode = false;
          }
        }).catch(() => {
          this.loadingPrintCode = false;
        });
      },
      // 标签打印3
      printCode3() {
        this.loadingPrintCode = true;
        this.$http.get("basic", `productionManage/printsn?id=${this.selection[0].pkid}`).then((resp) => {
          if (resp.success) {
            if (resp.data.length) {
              this.$refs.materialCodeModal3.open(resp.data, this.selection[0]);
            }
            this.loadingPrintCode = false;
          }
        }).catch(() => {
          this.loadingPrintCode = false;
        });
      },
      // 确认排产(支持批量)  待排产
      sureOutPut() {
        const arr = this.selection.filter((item) => item.status !== 10);
        const result = this.selection.find((item) => item.workCenterName === "分条");
        if (arr.length) {
          this.$confirm("请选择待排产的工单", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        // 如果选中的数据中工作中心为分条 其他工作中心也必须为分条 并且物料高度必须一致
        if (result) {
          const isAll = this.selection.find((item) => item.workCenterName !== "分条");
          if (isAll) {
            this.$confirm("请选择工作中心为分条的派工单", "错误", {
              type: "error",
              showCancelButton: false,
            });
          } else {
            const isEqual = this.selection.some((item) => this.selection.filter((ele) => ele.materialHeight !== item.materialHeight).length >= 1);
            if (isEqual) {
              this.$confirm("物料高度不一致", "错误", {
                type: "error",
                showCancelButton: false,
              });
            } else {
              if (!this.selection[0].materialHeight) {
                this.$confirm("物料高度不能为空", "错误", {
                  type: "error",
                  showCancelButton: false,
                });
              } else {
                this.$refs.inventorySelect.open(this.selection[0].materialHeight);
              }
            }
          }
        } else {
          // 选中的数据工作中心没有分条 直接排产
          const params = {
            taskList: this.selection,
            stockDetailId: "",
          };
          this.loadingSche = true;
          this.$http.post("basic", "productionManage/scheduling", params).then((resp) => {
            if (resp.success) {
              this.$message.success("排产成功");
              this.loadData(1);
              this.selection = [];
              this.loadingSche = false;
            }
          }).catch(() => {
            this.loadingSche = false;
          });
        }
      },

      // 撤销排产(支持批量) 已排产
      repealOutPut() {
        const result = this.selection.filter((item) => item.status !== 20);
        if (result.length) {
          this.$confirm("请选择已排产的工单", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          const ids = [];
          this.selection.forEach((item) => {
            ids.push(item.pkid);
          });
          this.loadingUnsche = true;
          this.$http.post("basic", "productionManage/cancel", ids).then((resp) => {
            if (resp.success) {
              this.$message.success("撤销成功");
              this.loadData(1);
              this.selection = [];
              this.loadingUnsche = false;
            }
          }).catch(() => {
            this.loadingUnsche = false;
          });
        }
      },

      // 选择库存明细 并排产
      inventorySelect(row) {
        let sum = 0;
        this.selection.forEach((item) => {
          sum += +item.materialWidth;
        });
        const params = {
          taskList: this.selection,
          stockDetailId: row.pkid,
          materialWidth: sum,
        };
        this.$http.post("basic", "productionManage/scheduling", params).then((resp) => {
          if (resp.success) {
            this.$message.success("排产成功");
            this.loadData(1);
            this.selection = [];
          }
        });
      },
    },
  };
</script>
